import { render, staticRenderFns } from "./TranscriptionDurationCard.vue?vue&type=template&id=dc76e6c8&scoped=true"
import script from "./TranscriptionDurationCard.vue?vue&type=script&lang=js"
export * from "./TranscriptionDurationCard.vue?vue&type=script&lang=js"
import style0 from "./TranscriptionDurationCard.vue?vue&type=style&index=0&id=dc76e6c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc76e6c8",
  null
  
)

export default component.exports